import { QueryClient } from '@tanstack/vue-query';
import type { ApiQuery } from '@/services/api/client';
import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';

// Nothing refetches on its own: the config must not change under a session, so
// KioskConfig decides when. http.ts already retries GETs and watches the network.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      networkMode: 'always',
    },
    mutations: {
      retry: false,
      networkMode: 'always',
    },
  },
});

exposeToGlobalScope(queryClient, 'QueryClient');

// A fetch that ignores the age of the cached answer. fetchQuery resolves with
// the new answer, but the cache keeps the objects of an unchanged one: a caller
// that compares references reads the cache.
export async function fetchShared<T>(query: ApiQuery<T>): Promise<T> {
  await queryClient.fetchQuery({ ...query, staleTime: 0 });
  return queryClient.getQueryData<T>(query.queryKey) as T;
}
